var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5116 36.2894C23.5068 36.2894 24.3222 37.1222 24.3222 38.1508C24.3222 39.1673 23.5068 40 22.5116 40C21.5044 40 20.689 39.1673 20.689 38.1508C20.689 37.1222 21.5044 36.2894 22.5116 36.2894ZM36.0011 36.2894C36.9963 36.2894 37.8117 37.1222 37.8117 38.1508C37.8117 39.1673 36.9963 40 36.0011 40C34.9938 40 34.1785 39.1673 34.1785 38.1508C34.1785 37.1222 34.9938 36.2894 36.0011 36.2894ZM17.0561 16.0105L19.9158 16.4501C20.3235 16.5248 20.6233 16.8665 20.6593 17.2829L20.8871 20.026C20.9231 20.4191 21.2348 20.713 21.6185 20.713H37.8119C38.5433 20.713 39.0229 20.9702 39.5026 21.5335C39.9822 22.0968 40.0661 22.905 39.9582 23.6386L38.8191 31.672C38.6033 33.2163 37.3083 34.3539 35.7855 34.3539H22.7037C21.1089 34.3539 19.7899 33.1061 19.658 31.4896L18.5549 18.1401L16.7443 17.8217C16.2647 17.736 15.9289 17.2584 16.0129 16.7685C16.0968 16.2677 16.5645 15.9358 17.0561 16.0105ZM33.867 25.2428H30.5456C30.0419 25.2428 29.6463 25.6469 29.6463 26.1613C29.6463 26.6634 30.0419 27.0797 30.5456 27.0797H33.867C34.3706 27.0797 34.7663 26.6634 34.7663 26.1613C34.7663 25.6469 34.3706 25.2428 33.867 25.2428Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.9b5715bfe2dc0cff8b95f397c14046da.svg";
export { ForwardRef as ReactComponent };